/*
==================================
TeaSource Dynamic Discount Timer
==================================

Purpose:
- Displays a live countdown timer for
  Shopify discounts created via Flow.
- Updates LOVE loyalty points to
  reflect the actual discounted price.

Requires:
- Product tag format:
  discount_PERCENT_START_END

- .ts-discount-data element with:
  data-active-discount

- LOVE points element:
  .ll__points-earned

Notes:
- Theme renders both desktop and
  mobile product info blocks.
- Timer updates all countdown
  instances found on the page.
==================================
*/



/* ==================================
   LOVE LOYALTY POINTS
   ================================== */

function updateLovePoints() {

  const pointsElements =
    document.querySelectorAll('.ll__points-earned');

  if (!pointsElements.length) return;

  const discountData =
    document.querySelector('.ts-discount-data');

  if (!discountData) return;

  const discountPercent =
    parseFloat(discountData.dataset.activeDiscount) || 0;


  /*
  ----------------------------------
  Find the currently selected variant
  ----------------------------------
  */

  let variantId = null;

  const urlParams =
    new URLSearchParams(window.location.search);

  variantId =
    urlParams.get('variant');


  /*
  ----------------------------------
  Try common Shopify variant selectors
  ----------------------------------
  */

  if (!variantId) {

    const variantInputs =
      document.querySelectorAll(
        'input[name="id"], select[name="id"]'
      );

    for (const input of variantInputs) {

      if (input.value) {
        variantId = input.value;
        break;
      }

    }

  }

  if (!variantId) return;


  /*
  ----------------------------------
  Get product data
  ----------------------------------
  */

  if (!window.tsProductDataPromise) {

    const productUrl =
      window.location.pathname
        .replace(/\/$/, '') + '.js';

    window.tsProductDataPromise =
      fetch(productUrl)
        .then(function(response) {

          if (!response.ok) {
            throw new Error(
              'Unable to load product data'
            );
          }

          return response.json();

        });

  }


  window.tsProductDataPromise
    .then(function(product) {

      const variant =
        product.variants.find(function(v) {

          return String(v.id) ===
            String(variantId);

        });

      if (!variant) return;


      /*
      ----------------------------------
      Regular price
      ----------------------------------
      */

      const regularPrice =
        parseFloat(variant.price) / 100;


      /*
      ----------------------------------
      Calculate discounted price
      ----------------------------------
      */

      let actualPrice =
        regularPrice;

      if (discountPercent > 0) {

        actualPrice =
          regularPrice *
          (1 - discountPercent / 100);

      }


      /*
      ----------------------------------
      LOVE points
      ----------------------------------

      One point per whole dollar paid.
      Always round down.

      Examples:
      $10.44 = 10 points
      $10.99 = 10 points
      $11.01 = 11 points
      $13.05 = 13 points
      $19.99 = 19 points
      ----------------------------------
      */

      const points =
        Math.floor(actualPrice);


      /*
      ----------------------------------
      Update LOVE
      ----------------------------------
      */

        pointsElements.forEach(function(element) {

          element.textContent = points;

          /*
          Reveal the entire LOVE message only
          after the correct number is in place.
          */

          const loveContainer =
            element.closest('.ll__product-ho4ed3');

          if (loveContainer) {

            loveContainer.classList.add(
              'ts-points-ready'
            );

          }

        });

    })
    .catch(function(error) {

      console.warn(
        'TeaSource LOVE points update failed:',
        error
      );

    });

}


/* ==================================
   TRY LOVE POINTS AFTER PAGE LOAD
   ==================================

   No MutationObserver.

   We simply give LOVE a few chances
   to appear after its app block loads.
   ================================== */

function tryLovePoints() {

  updateLovePoints();

}


/*
Try immediately
*/

tryLovePoints();


/*
Try again after 1 second
*/

setTimeout(function() {

  tryLovePoints();

}, 1000);


/*
Try again after 2 seconds
*/

setTimeout(function() {

  tryLovePoints();

}, 2000);


/*
Try again after 3 seconds
*/

setTimeout(function() {

  tryLovePoints();

}, 3000);


/* ==================================
   WATCH FOR VARIANT CHANGES
   ================================== */

document.addEventListener(
  'change',
  function(event) {

    if (
      event.target.matches(
        'input[name="id"], select[name="id"]'
      )
    ) {

      /*
      Immediately hide the LOVE message
      while the new variant points are
      being calculated.
      */

      const loveContainers =
        document.querySelectorAll(
          '.ll__product-ho4ed3'
        );

      loveContainers.forEach(function(container) {

        container.classList.remove(
          'ts-points-ready'
        );

      });


      /*
      Give Shopify/theme a moment to
      finish updating the selected variant.
      */

      setTimeout(function() {

        updateLovePoints();

      }, 150);

    }

  }
);


/* ==================================
   COUNTDOWN TIMER
   ==================================

   Keep the existing 2-second delay
   for the countdown.
   ================================== */

setTimeout(function() {

  const countdowns =
    document.querySelectorAll(
      '.ts-discount-countdown'
    );


  countdowns.forEach(function(countdown) {

    const timerDisplay =
      countdown.querySelector(
        '.ts-discount-time'
      );

    if (!timerDisplay) return;


    const endUnix =
      parseInt(countdown.dataset.end);


    function updateCountdown() {

      const now =
        Math.floor(Date.now() / 1000);


      const remaining =
        endUnix - now;


      if (remaining <= 0) {

        timerDisplay.innerHTML =
          'Sale Ended';

        return;

      }


      const days =
        Math.floor(
          remaining / 86400
        );


      const hours =
        Math.floor(
          (remaining % 86400) / 3600
        );


      const minutes =
        Math.floor(
          (remaining % 3600) / 60
        );


      const seconds =
        remaining % 60;


      timerDisplay.innerHTML =

        '<div class="ts-timer-numbers">' +

          ('0' + days).slice(-2) +
          ' : ' +

          ('0' + hours).slice(-2) +
          ' : ' +

          ('0' + minutes).slice(-2) +
          ' : ' +

          ('0' + seconds).slice(-2) +

        '</div>' +

        '<div class="ts-timer-labels">' +

          '<span>Days</span>' +
          '<span>Hours</span>' +
          '<span>Mins</span>' +
          '<span>Secs</span>' +

        '</div>';

    }


    updateCountdown();


    setInterval(
      updateCountdown,
      1000
    );

  });

}, 2000);